import { render, staticRenderFns } from "./addEditPosition.vue?vue&type=template&id=2d815a66"
import script from "./addEditPosition.vue?vue&type=script&lang=js"
export * from "./addEditPosition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports